import { Injectable, Injector } from '@angular/core';
import { _HttpClient } from '@delon/theme';
import { StockQuantityControlModalComponent } from '@shared-feature/components/modal/stock-quantity-control-modal/sqc-modal.component';
import { NzModalService } from 'ng-zorro-antd/modal';
import { FormService } from 'src/app/core/util/form.service';

interface Detail {
  stockId: number;
  uomId: number;
  stockLocationId: any;
  qty: number;
}

@Injectable()
export class StockQuantityControlService {
  constructor(
    private injector: Injector,
    private http: _HttpClient,
    private fs: FormService
  ) {}

  get modalService() {
    return this.injector.get(NzModalService);
  }

  /**
   * Check negative stock balance control
   * @param docType Document type (SINV, CS, DO, etc.)
   * @param dtls Item details array
   * @param qtyWasModify Whether quantity was modified
   * @param documentId Optional document ID for edit mode - excludes existing transactions from balance calculation
   */
  check(
    docType: string,
    dtls: any,
    qtyWasModify: boolean,
    documentId?: string
  ): Promise<boolean> {
    // Stock-IN doc types: refunds and credit notes return stock to inventory
    const isStockIn = ['CPF', 'SCN'].includes(docType);

    var getdtls = dtls
      .filter((x: any) => x.stock != null && x.isBundled !== true)
      .map((x: Detail) => {
        const movement = isStockIn
          ? -Math.abs(x.qty || 0)
          : Math.abs(x.qty || 0);
        return {
          DocType: docType,
          StockId: x.stockId,
          UOMId: x.uomId,
          LocationId: x.stockLocationId,
          OutQty: movement
        };
      });

    return new Promise((resolve, reject) => {
      //qtyWasModify is true if create or update
      if (qtyWasModify) {
        const payload: any = { details: getdtls };
        // Include documentId for edit mode to correctly calculate available stock
        if (documentId) {
          payload.documentId = documentId;
        }
        this.http
          .post(
            `api/negativeStockBalance/isNegativeStockBalanceControlAllow?_silent=true`,
            payload
          )
          .subscribe(res => {
            const type = res ? res[0]?.type : null;
            if (type === 'Warning') {
              const modal = this.modalService.create({
                nzTitle: 'Stock Quality Control',
                nzContent: StockQuantityControlModalComponent,
                nzWidth: '1000px',
                nzCentered: true,
                nzOnOk: () => resolve(true),
                nzOkText: 'Continue',
                nzOnCancel: () => reject(false)
              });
              const instance = modal.getContentComponent();
              instance.details = [...res];
            } else if (type === 'Block') {
              const modal = this.modalService.create({
                nzTitle: 'Stock Quality Control',
                nzContent: StockQuantityControlModalComponent,
                nzWidth: '1000px',
                nzCentered: true,
                nzFooter: [
                  {
                    label: 'Ok',
                    type: 'primary',
                    onClick: () => {
                      reject(false);
                      modal.destroy();
                    }
                  }
                ]
                // nzOnOk: () => reject(false),
              });
              const instance = modal.getContentComponent();
              instance.details = [...res];
            } else {
              resolve(true);
            }
          });
      } else {
        resolve(true);
      }
    });
  }
}
